/*
 * ds-header.js - header v3.
 * 1. Tiene aggiornato aria-expanded sul pulsante del menu quando il cassetto (theme-drawer di Horizon) si apre o si chiude;
 *    l'apertura la gestisce Horizon con on:click.
 * 2. Menu a tutta larghezza: Esc lo chiude (WCAG 1.4.13) finché il mouse o il focus non tornano su una voce.
 * 3. Rete di sicurezza: se la home non ha l'hero come prima sezione, l'header trasparente (classe ds-header-over sul body,
 *    messa dal layout) viene tolto, così il testo bianco non finisce su un fondo chiaro.
 */
const DRAWER_ID = 'ds-menu-drawer';

function sync() {
  const drawer = document.getElementById(DRAWER_ID);
  if (!drawer) return;
  const open = drawer.hasAttribute('open');
  for (const button of document.querySelectorAll(`[aria-controls="${DRAWER_ID}"]`)) {
    button.setAttribute('aria-expanded', String(open));
  }
}

for (const name of ['theme-drawer:open', 'theme-drawer:close']) {
  document.addEventListener(name, (event) => {
    if (event.target instanceof Element && event.target.id === DRAWER_ID) sync();
  });
}

const header = document.querySelector('[data-ds-header]');

if (header) {
  const reset = () => header.removeAttribute('data-ds-mega-off');
  header.addEventListener('pointerover', (event) => {
    if (event.target instanceof Element && event.target.closest('.ds-header__item')) reset();
  });
  header.addEventListener('focusin', reset);
  header.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (!header.querySelector('.ds-header__item:hover > .ds-mega, .ds-header__item:focus-within > .ds-mega')) return;
    const active = document.activeElement;
    if (active instanceof HTMLElement && header.contains(active)) {
      const top = active.closest('.ds-header__item')?.querySelector('.ds-header__link');
      if (top instanceof HTMLElement) top.focus();
    }
    header.setAttribute('data-ds-mega-off', '');
  });
}

if (document.body.classList.contains('ds-header-over') && !document.querySelector('#MainContent .shopify-section:first-child .ds-hero')) {
  document.body.classList.remove('ds-header-over');
}
